import MenuItem from '@mui/material/MenuItem';
import { lighten, styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';

export const StyledSideBarListItem = styled(MenuItem)(({ theme }) => ({
  paddingLeft: theme.spacing(6.5),
  paddingRight: theme.spacing(6.5),
  fontWeight: theme.typography.fontWeightMedium,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  transition: '0.5s',
  '&:hover': {
    backgroundColor: lighten(theme.palette.primary.main, 0.5) /* todo: temp fix, check with UX */,
  },
  '&.active': {
    backgroundColor: theme.palette.primary.light,
  },
}));

export const StyledSidebarMenuLink = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  textDecoration: 'none',
  padding: theme.spacing(2, 1),
  color: theme.palette.common.white,
  '&:hover': {
    textDecoration: 'none',
    color: theme.palette.common.white,
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 0),
  },
}));
